export enum TradingBlockDocumentNameDto {
  DriversLicense = 'DriversLicense',
  StateIdCard = 'StateIdCard',
  Passport = 'Passport',
  MilitaryId = 'MilitaryId',
  SsnCard = 'SsnCard',
  SsaLetter = 'SsaLetter',
  IrsItinLetter = 'IrsItinLetter',
  OtherGovernmentId = 'OtherGovernmentId',
  CddDocument = 'CddDocument',
  AllPassingCipResults = 'AllPassingCipResults',
  IrsW9Form = 'IrsW9Form',
  SignatureImage = 'SignatureImage',
  IdDocument = 'IdDocument',
  AffiliateApproval = 'AffiliateApproval',
  Document = 'Document',
  Other = 'Other',
  GovernmentId = 'GovernmentId',
}

export enum TradingBlockInvestigationCipCategoryStateDto {
  New = 'New',
  Pending = 'Pending',
  Indeterminate = 'Indeterminate',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Appealed = 'Appealed',
  Error = 'Error',
  Cancelled = 'Cancelled',
}

export enum TradingBlockApplicationCategoryNameDto {
  Signature = 'Signature',
  GovernmentId = 'GovermentId',
  AffiliateApproval = 'AffiliateApproval',
}

export enum TradingBlockInvestigationCategoryNameDto {
  Name = 'Name',
  DateOfBirth = 'DateOfBirth',
  TaxId = 'TaxId',
  Address = 'Address',
}

export enum TradingBlockUploadedDocumentStateDto {
  PendingReview = 'PendingReview',
  Submitted = 'Submitted',
  Rejected = 'Rejected',
}

export enum TradingBlockInvestigationStateDto {
  New = 'New',
  Pending = 'Pending',
  InvestigationSubmitted = 'InvestigationSubmitted',
  ReadyForBackOffice = 'ReadyForBackOffice',
  BackOffice = 'BackOffice',
  AccountSetup = 'AccountSetup',
  Complete = 'Complete',
  ActionRequired = 'ActionRequired',
  Rejected = 'Rejected',
  Suspended = 'Suspended',
  Error = 'Error',
  Cancelled = 'Cancelled',
  PendingSubmit = 'PendingSubmit',
}

export interface TradingBlockInvestigationAdminNoteDto {
  createdBy?: string;
  createdDate: string;
  id: string;
  text: string;
}

export interface TradingBlockApplicationCipCategoryDto {
  name: TradingBlockApplicationCategoryNameDto;
  isResolved: boolean;
  requestedDocuments?: Array<TradingBlockDocumentNameDto>;
}

export interface TradingBlockInvestigationCipCategoryDto {
  name: TradingBlockInvestigationCategoryNameDto;
  isResolved: boolean;
  state: TradingBlockInvestigationCipCategoryStateDto;
  requestedDocuments?: Array<TradingBlockDocumentNameDto>;
}

export interface TradingBlockApplicationUploadedDocumentDto {
  state: TradingBlockUploadedDocumentStateDto;
  documentId: string;
  documentName: TradingBlockDocumentNameDto;
  fileName: string;
  miscDocumentId: number;
  originalFileName: string;
  description?: string;
  takenOn?: string;
}

export interface TradingBlockInvestigationUploadedDocumentDto {
  state: TradingBlockUploadedDocumentStateDto;
  documentId: string;
  documentName: TradingBlockDocumentNameDto;
  fileName: string;
  miscDocumentId: number;
  originalFileName: string;
  description?: string;
  takenOn?: string;
  uploadDateTime?: string;
  uploadUserName?: string;
}

export interface TradingBlockInvestigationDto {
  adminNote?: string;
  adminNotes?: TradingBlockInvestigationAdminNoteDto[];
  cipCategories?: Array<TradingBlockInvestigationCipCategoryDto>;
  firstName?: string;
  investigationId: number;
  lastName?: string;
  state: TradingBlockInvestigationCipCategoryStateDto;
  uploadedDocuments?: Array<TradingBlockInvestigationUploadedDocumentDto>;
}

export interface TradingBlockApplicationDto {
  accountHolderId: number;
  appCategories?: Array<TradingBlockApplicationCipCategoryDto>;
  firstName?: string;
  lastName?: string;
  state?: TradingBlockInvestigationCipCategoryStateDto;
  uploadedDocuments?: Array<TradingBlockApplicationUploadedDocumentDto>;
}

export interface BaseInvestigationParamsDto {
  accountId: number;
}

export interface GetInvestigationListDto {
  params: BaseInvestigationParamsDto;
}

export interface GetInvestigationListResponseDto {
  applications?: TradingBlockApplicationDto[];
  investigations?: TradingBlockInvestigationDto[];
  state: TradingBlockInvestigationStateDto;
}

export interface UploadInvestigationDocumentParamsDto extends BaseInvestigationParamsDto {
  investigationId: number;
}

export interface FileDto {
  path: string;
  bytes: number;
  filename: string;
  headers: Record<string, string>;
}

export interface UploadInvestigationDocumentDto {
  params: UploadInvestigationDocumentParamsDto;
  body: FormData;
}

export interface UploadInvestigationDocumentResponseDto {
  description: string;
  documentName: string;
  imageName: string;
  takenOn: string;
}

export interface DownloadInvestigationDocumentParamsDto {
  accountId: number;
  investigationId: number;
  documentId: string;
}

export interface DownloadInvestigationDocumentDto {
  params: DownloadInvestigationDocumentParamsDto;
}

export interface AppealInvestigationsParamsDto extends BaseInvestigationParamsDto {}

export interface AppealInvestigationDto {
  params: AppealInvestigationsParamsDto;
}

export interface RejectInvestigationsParamsDto extends BaseInvestigationParamsDto {}

export interface RejectInvestigationDto {
  params: RejectInvestigationsParamsDto;
}

export interface SubmitInvestigationDocumentParamsDto extends BaseInvestigationParamsDto {
  miscDocumentId: number;
}

export interface SubmitInvestigationDocumentDto {
  params: SubmitInvestigationDocumentParamsDto;
}

export interface DeleteInvestigationDocumentParamsDto extends BaseInvestigationParamsDto {
  miscDocumentId: number;
}

export interface DeleteInvestigationDocumentDto {
  params: DeleteInvestigationDocumentParamsDto;
}

export interface UploadApplicationDocumentParamsDto extends BaseInvestigationParamsDto {
  accountHolderId: number;
}

export interface UploadApplicationDocumentDto {
  params: UploadApplicationDocumentParamsDto;
  body: FormData;
}

export interface UploadApplicationDocumentResponseDto {
  description: string;
  documentName: string;
  imageName: string;
  takenOn: string;
}

export interface DownloadApplicationDocumentParamsDto {
  accountId: number;
  accountHolderId: string;
  documentId: string;
}

export interface DownloadApplicationDocumentDto {
  params: DownloadApplicationDocumentParamsDto;
}

export interface SubmitApplicationDocumentParamsDto extends BaseInvestigationParamsDto {
  miscDocumentId: number;
}

export interface SubmitApplicationDocumentDto {
  params: SubmitInvestigationDocumentParamsDto;
}

export interface ContinueApplicationDto {
  params: BaseInvestigationParamsDto;
}

export interface ContinueApplicationResponseDto {
  accountId: number;
  accountNUmber?: string;
  state: TradingBlockInvestigationStateDto;
}

export interface DeleteApplicationDocumentParamsDto extends BaseInvestigationParamsDto {
  miscDocumentId: number;
}

export interface DeleteApplicationDocumentDto {
  params: DeleteApplicationDocumentParamsDto;
}
